import { render, staticRenderFns } from "./PopularTag.vue?vue&type=template&id=5188e4c2&scoped=true"
import script from "./PopularTag.vue?vue&type=script&lang=js"
export * from "./PopularTag.vue?vue&type=script&lang=js"
import style0 from "./PopularTag.vue?vue&type=style&index=0&id=5188e4c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5188e4c2",
  null
  
)

export default component.exports